import MuiCheckbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import type { ComponentProps, ForwardedRef, ReactNode } from 'react';
import { forwardRef, useId } from 'react';

type Props = ComponentProps<typeof MuiCheckbox> & {
  label: ReactNode;
  hideLabel?: boolean;
  error?: string;
  readOnly?: boolean;
};

export const Checkbox = forwardRef(function CustomInput(
  { label, hideLabel, readOnly, error, ...props }: Props,
  ref: ForwardedRef<HTMLButtonElement>,
) {
  const errorId = useId();
  return (
    <FormControl error={!!error}>
      <FormControlLabel
        style={hideLabel ? { margin: '0' } : undefined}
        label={hideLabel ? undefined : label}
        control={
          <MuiCheckbox
            ref={ref}
            inputProps={{
              readOnly,
            }}
            readOnly={readOnly}
            aria-describedby={errorId}
            aria-label={
              hideLabel && typeof label === 'string' ? label : undefined
            }
            {...props}
          />
        }
      />
      {!!error && <FormHelperText id={errorId}>{error}</FormHelperText>}
    </FormControl>
  );
});
